import * as amplitude from '@amplitude/analytics-browser';
import ls from 'lib/core/storageFactory';

const AMPLITUDE_API_KEY = process.env.REACT_APP_SHELF_AMPLITUDE_API_KEY;
const ENV = process.env.REACT_APP_SHELF_DEPLOYMENT_ENV;
const APP_VERSION = process.env.REACT_APP_SHELF_VERSION;
const IS_DEV = ENV === 'local';

let initialized = false;

function getCommonProperties() {
  const properties = {
    app_version: APP_VERSION,
    environment: ENV,
  };

  const client = ls.get('client');
  if (client) {
    properties.client = client;
  }

  return properties;
}

function devLog(method, ...args) {
  if (IS_DEV) {
    console.log(`[Analytics] ${method}`, ...args);
  }
}

export function init() {
  if (initialized) {
    if (IS_DEV) console.log('[Analytics] Already initialized');
    return;
  }

  if (!AMPLITUDE_API_KEY) {
    console.warn('Analytics disabled.');
    return;
  }

  try {
    amplitude.init(AMPLITUDE_API_KEY, undefined, {
      defaultTracking: {
        sessions: true,
        pageViews: false,
        formInteractions: false,
        fileDownloads: false,
      },
      logLevel: IS_DEV ? amplitude.Types.LogLevel.Warn : amplitude.Types.LogLevel.None,
      // Disable auto plugin loading to avoid web-vitals transpilation issues
      plugins: [],
    });

    initialized = true;
    if (IS_DEV) {
      console.log('[Analytics] Initialized successfully');
    }
  } catch (error) {
    if (IS_DEV) {
      console.error('[Analytics] Initialization failed:', error);
    } else {
      console.error('Analytics initialization failed.');
    }
  }
}

export function identifyUser(userId, userProperties) {
  if (!initialized) return;

  if (userId) {
    amplitude.setUserId(userId);
    devLog('identify', userId);
  }

  if (userProperties && typeof userProperties === 'object') {
    const identifyEvent = new amplitude.Identify();
    Object.entries(userProperties).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        identifyEvent.set(key, value);
      }
    });
    amplitude.identify(identifyEvent);
    devLog('setUserProperties', userProperties);
  }
}

export function reset() {
  if (!initialized) return;

  amplitude.reset();
  devLog('reset', 'User identity cleared');
}

export function track(eventName, eventProperties) {
  if (!initialized) {
    if (IS_DEV) {
      console.warn('[Analytics] Cannot track - not initialized.');
    }
    return;
  }

  const enrichedProperties = {
    ...getCommonProperties(),
    ...eventProperties,
  };

  amplitude.track(eventName, enrichedProperties);
  devLog('track', eventName, enrichedProperties);
}

export function setUserProperties(properties) {
  if (!initialized) return;

  const identifyEvent = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      identifyEvent.set(key, value);
    }
  });
  amplitude.identify(identifyEvent);
  devLog('setUserProperties', properties);
}
